module.exports = __webpack_public_path__ + "img/1554387746.1363baf8.jpg";